export default {
    change_status_title: "Change Status",
    change_status_the_status_has_been_changed: "The status has been changed",
    change_status_it_was_possible_to_change_the_status: "It is not possible to change status",
    change_status_device_name: "Device Name",
    change_status_status: "Status",
    change_status_warning_status: "Some of the selected devices already have this status",
    change_status_change: "Change",
    change_status_error_scheduled_action: "Entities cannot have several scheduled action",
    change_status_error_scheduled: "There is an error when creating a scheduled action",
    change_status_immediately: "Immediately",
    change_status_schedule: "Schedule",
    change_status_scheduled_at: "Scheduled At",
    change_status_additional_change: "Additional Change",
    change_status_scheduled_actions: "Scheduled Actions",
    change_status_serial: "Serial",
    change_status_new_status: "New Status",
    change_status_show_in_web: "Show In Web",
    change_status_scheduled_on: "Scheduled On",
    change_status_apply_status: "Apply Status",
    change_status_error_date: "The date must be higher",
    change_status_error_status: "The status must not be the same",
    change_status_error_same_date: "There are already scheduled actions for those dates",
    change_status_error_same_status: "There are already scheduled actions for those status",
    change_status_devices_already_scheduled_actions: "The devices already have scheduled actions",
    change_status_device_already_scheduled_actions: "The device has already scheduled actions",
    change_status_error_status_by_date: "There are actions scheduled for this status",
    change_status_transaction_message: "The request to change the status of the devices has been sent successfully, please check the transactions list to see the status of the request.",
};
